import React from 'react';
import {Checkbox, Col, Form, Row, Radio, Space} from "antd";
import PropTypes from 'prop-types'

const SurveyForm = ({colOffset, form}) => {

    const colStyle = {marginBottom: -30};

    return (
        <Row>
            <Col offset={colOffset} xs={24 - 2 * colOffset} style={{marginBottom: 10}} >
                <Form form={form} layout="vertical">

                    {/*<Row>*/}
                    {/*    <Col xs={24} style={colStyle}>*/}
                    {/*        <Form.Item name='acceptanceLetter' valuePropName='checked' initialValue={false}>*/}
                    {/*          <Checkbox data-cy='acceptanceLetter'>Please send me a Acceptance Letter by email.</Checkbox>*/}
                    {/*        </Form.Item>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}

                    <Row>
                        <Col xs={24} style={colStyle}>
                            <Form.Item name='invitationLetter' valuePropName='checked' initialValue={false}>
                                <Checkbox data-cy='invitationLetter'>Please send me a Invitation Letter for a Visa Application.</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row>
                        <Col xs={24} style={colStyle}>
                            <Form.Item name='certificate' valuePropName='checked' initialValue={false}>
                                <Checkbox data-cy='certificate'>I need certificate of attendance.</Checkbox>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row style={{marginTop: 10, marginBottom: 10}}>
                        <Col xs={24} style={colStyle}>
                            <Form.Item name='source' label='How did you hear or learn about this Conference?'>
                                <Radio.Group>
                                    <Space direction="vertical" size={2}>
                                    <Radio value="flyer"> Flyer </Radio>
                                    <Radio value="www"> Conference website </Radio>
                                    <Radio value="email"> Email invitation / Newsletter </Radio>
                                    <Radio value="conf"> Another conference or previous edition of Numiform</Radio>
                                    <Radio value="other"> Other</Radio>
                                    </Space>
                                </Radio.Group>
                            </Form.Item>
                        </Col>
                    </Row>


                </Form>
            </Col>
        </Row>
    );
}

SurveyForm.propTypes = {
    user: PropTypes.object,
    action: PropTypes.func,
    colOffset: PropTypes.number,
};

SurveyForm.defaultProps = {
    colOffset: 2
}

// export default Form.create({})(SurveyForm);
export default SurveyForm;
